import { object } from 'prop-types'
import { isAfter } from 'date-fns'
import { BaseFeedbackConIcona } from 'feedback'
import { BaseGridLayout } from 'layout'
import { generaUUID, oggiInizioGiornata, unisciDataConOrario } from 'utils'
import { BaseButtons } from './BaseButtons'
import BaseTimeInput from './BaseTimeInput'
import useControllerSeServe from './hooks/ControllerSeServeHook'
import useInputGenerico from './hooks/InputGenericoHook'

BaseTimeIntervalsInput.propTypes = {
  propsBottoneElimina: object,
  propsBottoneAggiungi: object,
  ...useInputGenerico.propTypes
}

export default function BaseTimeIntervalsInput(props) {
  const {
    propsBottoneElimina,
    propsBottoneAggiungi,
    ...restProps
  } = props

  const inputGenericoProps = useInputGenerico({
    componenteControllato: true,
    ...restProps,
  })

  const {
    value: intervalliSenzaUuid,
    // onBlur,
    onChange,
    // ref,
    propsRimanenti,
  } = useControllerSeServe(inputGenericoProps)

  const intervalli = intervalliSenzaUuid.map(
    intervallo => intervallo.uuid ? intervallo : { ...intervallo, uuid: generaUUID() }
  )

  function aggiungiIntervallo() {
    onChange([...intervalli, { first: '', second: '', uuid: generaUUID() }])
  }

  function modificaIntervallo(uuidDaModificare, valoreDaUnire) {
    onChange(intervalli.map(
      intervallo => intervallo.uuid === uuidDaModificare ? { ...intervallo, ...valoreDaUnire } : intervallo)
    )
  }

  function eliminaIntervallo(uuidDaEliminare) {
    onChange(intervalli.filter(intervallo => intervallo.uuid !== uuidDaEliminare))
  }

  function isIntervalloValido(inizio, fine) {
    if (inizio.length !== 5 || fine.length !== 5) return true
    const data = oggiInizioGiornata()
    const dataInizio = unisciDataConOrario(data, inizio)
    const dataFine = unisciDataConOrario(data, fine)
    return !isAfter(dataInizio, dataFine)
  }

  return (
    <>
      {intervalli.map(({ first, second, uuid }) =>
        <BaseGridLayout key={uuid} alignCenter>
          <BaseTimeInput
            label='Ora inizio'
            nonUsareHookForm
            value={first}
            onChange={e => modificaIntervallo(uuid, { first: e.target.value })}
            {...propsRimanenti}
          />
          <BaseTimeInput
            label='Ora fine'
            nonUsareHookForm
            value={second}
            onChange={e => modificaIntervallo(uuid, { second: e.target.value })}
            {...propsRimanenti}
          />
          <BaseFeedbackConIcona.Errore
            messaggio='Ora inizio non può essere dopo Ora fine'
            hidden={isIntervalloValido(first, second)}
          />
          <BaseButtons.Elimina
            onClick={() => eliminaIntervallo(uuid)}
            variant='text'
            size='small'
            noMarginY
            sx={{ mt: 1 }}
            hidden={inputGenericoProps.disabled}
            {...propsBottoneElimina}
          />
        </BaseGridLayout>
      )}

      {!inputGenericoProps.disabled &&
        <BaseButtons.Aggiungi
          onClick={() => aggiungiIntervallo()}
          color='success'
          variant='text'
          size='small'
          noMarginY
          {...propsBottoneAggiungi}
        />
      }
    </>
  )
}